import React from 'react'

const Shipping_policy = () => {
  return (
    <div className="container my-5">
    <div className="card shadow border-0 p-4">
      <h2 className="text-center mb-4 fw-bold text-primary">Shipping Policy</h2>

      <p className="text-muted mb-4">
        <strong>Dartex Technology Private Limited</strong> (Dartex, “we”, “our”)
        provides courier aggregation services that connect sellers with multiple courier
        partners. This Shipping Policy outlines how shipping, delivery, and returns are
        managed through our platform.
      </p>

      <section className="mb-4">
        <h5 className="fw-semibold">1. Service Coverage</h5>
        <ul className="mt-2">
          <li>
            We provide delivery services across 27,000+ pincodes in India through partnered
            courier companies.
          </li>
          <li>
            Serviceability may vary depending on courier partner availability, service
            type, and delivery location.
          </li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">2. Order Processing</h5>
        <ul className="mt-2">
          <li>Orders must be booked through the Dartex dashboard.</li>
          <li>All shipping labels and invoices must be generated accurately by the Seller.</li>
          <li>
          Dartex is not responsible for incorrect addresses, phone numbers, or buyer
            details entered by the Seller.
          </li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">3. Delivery Timelines</h5>
        <ul className="mt-2">
          <li>
            Deliveries are subject to the serviceability and timelines of the chosen courier
            partner.
          </li>
          <li>Standard delivery times range from 2 to 7 working days depending on location.</li>
          <li>
            Delays may occur due to weather, strikes, holidays, or unforeseen circumstances.
          </li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">4. Return to Origin (RTO)</h5>
        <ul className="mt-2">
          <li>If delivery fails after multiple attempts, the parcel will be returned to the Seller.</li>
          <li>RTO charges are borne by the Seller.</li>
          <li>COD RTO parcels will not be remitted to Sellers.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">5. Prohibited Items</h5>
        <p className="mt-2">
          Sellers are prohibited from shipping items banned by law or by courier partners,
          including but not limited to:
        </p>
        <ul>
          <li>Illegal substances, narcotics, and hazardous materials</li>
          <li>Perishable items without proper packaging</li>
          <li>Liquids, fragile goods, or valuable items not declared properly</li>
          <li>Counterfeit, pirated, or restricted goods</li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">6. Liability</h5>
        <ul className="mt-2">
          <li>
          Dartex does not handle or check parcels. We are not responsible for damages,
            quality issues, shortages, or disputes between Seller and Buyer.
          </li>
          <li>
            Any transit damage or loss claims must be raised with the respective courier
            partner as per their claim process.
          </li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">7. Tracking</h5>
        <p className="mt-2">
          Sellers and Buyers can track shipments using tracking IDs provided by courier
          partners through the Dartex dashboard.
        </p>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">8. Force Majeure</h5>
        <p className="mt-2">
        Dartex shall not be liable for delays or failures due to events beyond our
          control, including natural disasters, strikes, or government restrictions.
        </p>
      </section>

      <p className="text-muted mt-4">
        By shipping with Dartex, you agree to this <strong>Shipping Policy</strong>.
      </p>
    </div>
  </div>
  )
}

export default Shipping_policy
